import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";

import { ConfigService } from "../config/config.service";
import { fromMinutesToMilliseconds } from "../utils/conversions/time-conversion";

@Injectable({
	providedIn: "root",
})
export class BrowserEventsConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getRefreshTimeLimitMs(): number {
		return fromMinutesToMilliseconds(
			this.configService.get((x) => x.global.browserEvents.refreshTimeLimitMinutes, 5)
		);
	}
}
